import Hero from './hero';
import Features from './features';
import MiniFeatures from './mini-features';
import Reviews from './reviews';
import Pricing from '../memberships/pricing';
import MerchSection from './merch';
import FinalCTA from './final-cta';

import { Box, FadeSlideIn, DesktopFooter  } from 'src/components';

export default function Home() {

  const isMembershipsEnabled = import.meta.env.VITE_FEATURE_MEMBERSHIPS === 'true';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        width: '100%',
        minHeight: '100vh',
        overflowX: 'clip',
        bgcolor: '#fafafa'
      }}>
    
      <Hero />

      {/*<FadeSlideIn delay={0.1}>
        <Reviews />
      </FadeSlideIn>*/}

      <FadeSlideIn delay={0.2}>
        <Features />
      </FadeSlideIn>

      <FadeSlideIn delay={0.3}>
        <MerchSection />
      </FadeSlideIn>

      <FadeSlideIn delay={0.4}>
        <MiniFeatures />
      </FadeSlideIn>

      {isMembershipsEnabled && (
        <FadeSlideIn delay={0.5}>
          <Pricing />
        </FadeSlideIn>
      )}

      <FadeSlideIn delay={0.6}>
        <FinalCTA />
      </FadeSlideIn>

      <DesktopFooter />

    </Box>
  );
}
